















import Vue from "vue";
import config from "@/configs";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "LogoutModalIdle",

  computed: {
    isNotInLoginPage(): boolean {
      return !this.$route.path.includes("login") && this.$route.path !== "/";
    },
    show(): boolean {
      return (
        this.isNotInLoginPage &&
        !!config?.settings?.idleTime &&
        this.$store.state.idleVue.isIdle
      );
    },
    idleTime(): number {
      return config?.settings?.idleTime || 0;
    },
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    onShowChanged(newVal: boolean): void {
      // logout only when is not in login page or root and the user has some activity
      if (this.isNotInLoginPage && !newVal) {
        this.logout({ redirect: true });
      }
    },
  },
  watch: {
    show: {
      handler: "onShowChanged",
      immediate: true,
    },
  },
});
